import type { FC, ReactNode } from 'react';
import React from 'react';
import { isUserAgentBot } from 'app/shared/utils/userAgentUtils';
import { BotContext } from '@zillow/react-deferred-hydration';

interface BotProviderProps {
  children: ReactNode;
  userAgent: string;
  isChatGPT?: boolean;
}

const BotProvider: FC<BotProviderProps> = ({ children, userAgent, isChatGPT = false }) => {
  const isSearchEngineCrawler = isUserAgentBot(userAgent);

  // Combined bot flag: render immediately for any type of bot (search engines OR agentic browsers)
  const shouldRenderImmediately = isSearchEngineCrawler || isChatGPT;

  return (
    <BotContext.Provider value={{ isSearchEngineCrawler: shouldRenderImmediately }}>{children}</BotContext.Provider>
  );
};

export default BotProvider;
